import React, { useState } from "react";
import Upload from "./upload";
import Tutorial from "./tutorial";
import "./app.css";
import WizardHelpContent from "./wizardhelpcontent";
var App = function () {
    var _a = useState(null), sd = _a[0], setSD = _a[1];
    var _b = useState([]), selectedClassifications = _b[0], setSelected = _b[1]; // just tags
    var _c = useState(true), showHelp = _c[0], setShowHelp = _c[1];
    var toggleShowhelp = function () { setShowHelp(false); };
    var setClassifications = function (classifications) {
        setSelected(classifications);
    };
    return (React.createElement("div", { className: "App" },
        React.createElement("div", { className: "App-row" },
            !sd && showHelp && React.createElement("div", { className: "App-col" },
                React.createElement("h3", null, "Identify data classification labels applicable to your service and resources"),
                React.createElement(WizardHelpContent, { onSelect: setClassifications, selectedClassifications: selectedClassifications, closeClicked: toggleShowhelp })),
            React.createElement("div", { className: "App-col" },
                !sd && !showHelp && React.createElement(AskForFile, { setSD: setSD }),
                sd && !showHelp && React.createElement(Start, { sd: sd, classificationList: selectedClassifications })))));
};
var AskForFile = function (_a) {
    var setSD = _a.setSD;
    return (React.createElement("div", { className: "App-askForFile" },
        React.createElement("p", null,
            "Service ",
            process.env.REACT_APP_SERVICE_NAME,
            " is running in environment ",
            process.env.REACT_APP_ENVIRONMENT),
        React.createElement(Upload, { onUpload: function (sd) { return setSD(sd); } })));
};
var Start = function (_a) {
    var sd = _a.sd, classificationList = _a.classificationList;
    return (React.createElement("div", { className: "App-start" },
        React.createElement(Tutorial, { sd: sd, classificationList: classificationList })));
};
export default App;
